module.exports = __webpack_public_path__ + "static/media/traffic.5fa63bfb.png";